<template>
  <div>
    <QsDrawer
      :title="title"
      :visible.sync="visible"
      :before-close="handleClose"
      @open="handleOpened"
    >
      <div class="demo-drawer__content" v-loading="loading">
        <Info v-if="isDetail && !infoStatus" :userInfo="formData" />
        <div v-else class="card">
          <div class="card-title">基础信息</div>
          <el-form
            :model="formData"
            ref="formRef"
            :rules="rules"
            class="form-container"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="userName">
                  <el-input
                    v-model="formData.userName"
                    autocomplete="off"
                    placeholder="请输入"
                    maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="账号" prop="userAccount">
                  <el-input
                    :disabled="isEdit || infoStatus"
                    v-model="formData.userAccount"
                    maxlength="20"
                    placeholder="请输入"
                  >
                    <template slot="append">{{ append }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="手机号" prop="userMobile">
                  <el-input
                    v-model="formData.userMobile"
                    placeholder="请输入"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="isEdit || infoStatus">
                <el-form-item label="钉钉组织绑定" prop="dingOrgName">
                  <el-input v-model="formData.dingOrgName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="loginWithPassword && isAdd">
                <el-form-item prop="password">
                <template #label>
                <div class="customLabel">
                  <div>密码</div>
                  <el-button type="text" class="copy"
                  v-clipboard:copy="formData.password"
                  v-clipboard:success="onCopy"
                  >复制密码</el-button>
                </div>
                </template>
                  <el-input
                    v-model="formData.password"
                    autocomplete="off"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <DeptSelector
                  v-model="formData.deptId"
                  label="所属部门"
                  prop="deptId"
                  :isAll="true"
                  :multiple="false"
                />
              </el-col>
              <el-col :span="12">
                <el-form-item label="角色权限" prop="roleIdList">
                  <QS-select
                    v-model="formData.roleIdList"
                    :optionData="roleTreeData"
                    :optionConfig="{
                      valueKey: 'id',
                      labelKey: 'name',
                    }"
                    filterable
                    clearable
                    multiple
                    placeholder="请选择角色权限"
                  />
                </el-form-item>
                <div class="tip">
                    未找到所属角色？<span class="color-primary" @click="addrole"
                      >去创建</span
                    >
                  </div>
              </el-col>
              <el-col :span="12">
                <el-form-item label="员工照片" prop="avatar">
                  <UploadCommon
                    :fileList="formData.avatar"
                    :isAlone="false"
                    :isShowCustom="false"
                    :limit="1"
                    :sizeType="4"
                    commonUpload
                    group="group"
                    code="group_employee_pic"
                    @uploadBefore="uploadBefore"
                    @uploadSuccess="uploadSuccess"
                    @uploadError="uploadError"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <template #footer>
        <el-button
          v-for="btn in btns"
          :type="btn.type"
          :key="btn.key"
          @click="btn.onClick"
          >{{ btn.label }}</el-button
        >
      </template>
    </QsDrawer>
    <AddAndEditRoleDrawer
      :visible.sync="roleVisible"
      :mode="3"
      @refresh="handleRefresh"
    />
    <resetPwdDialog ref="resetPwdRef"/>
    <WxBindDialog ref="wxBindDialogRef" @refresh="getDetailInfo" />
  </div>
</template>
<script setup>
import { ref, reactive, computed } from 'vue'
import { Message, MessageBox } from '@qs/ui'
import DeptSelector from '@/components/DeptSelect/WithLabel.vue'
import QsDrawer from '@/components/QsDrawer'
import {
  tRoleList,
  addStaff,
  editStaff,
  getStaffDetail,
  getStaffDetailSensitive,
} from '@/api/domain/organize'
import AddAndEditRoleDrawer from '@/pages/organize/groupRoleMange/components/addAndEditRole.vue'
import { useStoreGetters, useStoreActions } from '@/store/hooks'
import { useGetUrl } from '@/utils/useUploadCommon'
import { truncateToChar } from '@/utils/index'
import { handleStateStaff } from '../hooks'
import { validateMobile } from '@/utils/validate'
import Info from './info.vue'
import { generatePassword, pwdReg, pwdErrInfo } from '@/utils/passwordValidate'
import resetPwdDialog from './resetPwdDialog.vue'
import { usePermission } from '@/utils/useUtils'
import { hasWechatLoginBinding } from '@/utils/wechatBinding'
import { getCloudConfig } from '@/api/login'
import { unbindWechatLogin } from '@/api/wechatLogin'
import WxBindDialog from './WxBindDialog.vue'

const judgePermission = usePermission()

// 场景
const SCENE = {
  ADD: 'add',
  EDIT: 'edit',
  DETAIL: 'detail',
}

const props = defineProps({
  currentNode: {
    type: Object,
  },
})

const emits = defineEmits(['refresh'])

const getUrl = useGetUrl()
const { userInfo } = useStoreGetters(['userInfo'])
const { GetUserInfo } = useStoreActions(['GetUserInfo'])


const loading = ref(false)
const append = computed(() => `@${userInfo.tenantShortName}`)
const visible = ref(false)
const roleVisible = ref(false)
const staffId = ref(null)

const infoStatus = ref(false)
// 载入时手机号快照，用于判断保存时是否更换了手机号
const originMobile = ref('')
// 员工绑定信息（bindings），只读、不参与表单，单独存放
const staffBindings = ref([])
const scene = ref(SCENE.ADD)
const isEdit = computed(() => scene.value === SCENE.EDIT)
const isAdd = computed(() => scene.value === SCENE.ADD)
const isDetail = computed(() => scene.value === SCENE.DETAIL)
const resetPwdRef = ref(null)
const wxBindDialogRef = ref(null)
// 员工是否已绑定微信登录
const staffWechatBound = computed(() => hasWechatLoginBinding(staffBindings.value))
const title = computed(() => {
  if (isDetail.value && !infoStatus.value) return '员工详情'
  if (isAdd.value) return '新增员工'
  return '编辑员工'
})
const formRef = ref(null)
const rules = reactive({
  userName: [{ required: true, message: '请输入姓名', trigger: 'change' }],
  userAccount: [
    { required: true, message: '请输入账号', trigger: 'change' },
    {
      pattern: /^[0-9a-zA-Z_]{1,20}$/,
      message: '请输入20位以内的数字或字母、_',
      trigger: 'change',
    },
  ],
  userMobile: [
    { required: true, message: '请输入手机号', trigger: 'change' },
    { validator: validateMobile, trigger: 'change' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'change' },
    {
      pattern: pwdReg,
      message: pwdErrInfo,
      trigger: 'change',
    },
  ],
  deptId: [{ required: true, message: '请选择部门', trigger: 'change' }],
  roleIdList: [
    { required: true, message: '请选择角色权限', trigger: 'change' },
  ],
})

// 角色基础数据
const roleTreeData = ref([])
// 表单数据
const formData = ref({
  deptId: '',
  userName: '',
  userAccount: '',
  password: '',
  avatar: [],
  userMobile: '',
  roleIdList: [],
  dingOrgName: '', // 钉钉组织绑定
})

const loginWithPassword = ref(false)
const onCopy = () => {
  Message.success('复制成功')
}
const addrole = () => {
  roleVisible.value = true
}

const handleEditStaff = async () => {
  infoStatus.value = true
  scene.value = SCENE.EDIT
  await getDetailInfo()
}
// 绑定微信登录：打开扫码弹窗
const handleBindWechatLogin = () => {
  wxBindDialogRef.value.open({
    id: staffId.value,
    userName: formData.value.userName,
    userAccount: `${formData.value.userAccount}@${userInfo.tenantShortName}`,
  })
}
// 解绑微信登录：二次确认后调用
const handleUnbindWechatLogin = () => {
  MessageBox.confirm(
    `确定解绑员工「${formData.value.userName}」的微信登录吗？解绑后该微信将无法扫码登录此账号。`,
    '解绑微信登录',
    {
      confirmButtonText: '确定解绑',
      cancelButtonText: '取消',
      type: 'warning',
    },
  ).then(() => unbindWechatLogin({ userId: staffId.value })).then((res) => {
    if (res && res.code === 1) {
      Message.success('解绑成功')
      getDetailInfo()
    }
  }).catch(() => {
    // 用户取消或请求失败（msg 已由 request 弹出）
  })
}
// 如果 id 和 status 都没有 是新增  只有id 没有 status 为编辑
const btns = computed(() => {
  if (isDetail.value && !infoStatus.value) {
    const arr = []
    judgePermission('staff_enable_staff') && arr.push({
      label: `账号${!formData.value.state ? '启用' : '禁用'}`,
      type: 'default',
      key: 3,
      onClick: () => handleStateStaff(formData.value, getDetailInfo),
    })
    loginWithPassword.value && judgePermission('staff_reset_password') && arr.push({
      label: '密码重置',
      type: 'default',
      key: 2,
      onClick: () => resetPwdRef.value.open(staffId.value),
    })
    judgePermission('staff_edit_staff') && arr.push(staffWechatBound.value
      ? {
        label: '解绑微信登录',
        type: 'default',
        key: 6,
        onClick: () => handleUnbindWechatLogin(),
      }
      : {
        label: '绑定微信登录',
        type: 'default',
        key: 7,
        onClick: () => handleBindWechatLogin(),
      })
    judgePermission('staff_edit_staff') && arr.push({
      label: '编辑',
      type: 'primary',
      key: 1,
      onClick: () => handleEditStaff(),
    })
    return arr
  }

  return [
    {
      label: '取消',
      type: 'default',
      key: 4,
      onClick: handleCancel,
    },
    {
      label: '保存',
      type: 'primary',
      key: 5,
      onClick: handleSave,
    },
  ]
})

const getDetailInfo = async () => {
  const detailApi = isDetail.value ? getStaffDetailSensitive : getStaffDetail
  const { code, data } = await detailApi({ id: staffId.value })
  if (code !== 1) return
  // bindings 不参与表单，剥离后单独存放，避免随 formData 提交回后端
  const { bindings, ...rest } = data
  staffBindings.value = bindings || []
  formData.value = {
    ...rest,
    userAccount: truncateToChar(data.userAccount, '@'),
    tenantShortName: userInfo.tenantShortName,
    avatar: getUrl({
      data: data.avatar,
      needName: true,
    }),
    roleIdList: data?.roleList?.map((item) => item.id) || [],
    deptId: data.deptId,
  }
  originMobile.value = data.userMobile || ''
}
const openDrawer = async (data) => {
  const { id, status } = data
  visible.value = true
  scene.value = status
  if (id) {
    staffId.value = id
    await getDetailInfo()
  }
  getLoginCloudConfig()
}

const handleOpened = async () => {
  if (scene.value === SCENE.ADD) {
    formData.value.deptId = props.currentNode.id
    formData.value.password = generatePassword()
  }
  getRoleListData()
}
const closeDrawer = () => {
  visible.value = false
}

const handleRefresh = () => {
  getRoleListData()
}
// 初始化获取角色数据
const getRoleListData = async () => {
  loading.value = true
  const { code, data } = await tRoleList({ pageSize: 9999, pageNum: 1 })
  loading.value = false
  if (code === 1) {
    roleTreeData.value = data.items
  }
}

// 关闭弹窗
const handleClose = () => {
  formRef?.value?.resetFields()
  infoStatus.value = false
  staffId.value = null
  staffBindings.value = []
  formData.value = {
    deptId: '',
    userName: '',
    userAccount: '',
    password: '',
    avatar: [],
    userMobile: '',
    roleIdList: [],
    dingOrgName: '', // 钉钉组织绑定
  }
  closeDrawer()
}

const fileLoading = ref(false)
const uploadBefore = () => {
  fileLoading.value = true
}
const uploadSuccess = () => {
  fileLoading.value = false
}
const uploadError = () => {
  fileLoading.value = false
}
// 提交表单
const handleSave = async () => {
  if (fileLoading.value) {
    Message.info('请等待图片上传完成')
    return
  }
  const valid = await formRef.value.validate()
  if (!valid) return

  // 编辑场景更换手机号且已绑微信登录：二次确认（后端随更号自动解绑，前端不加解绑参数）
  if (
    staffId.value
    && hasWechatLoginBinding(staffBindings.value)
    && formData.value.userMobile !== originMobile.value
  ) {
    try {
      await MessageBox.confirm(
        '更换手机号将同时解绑该员工的微信登录，是否继续？',
        '更换手机号',
        {
          confirmButtonText: '继续',
          cancelButtonText: '取消',
          type: 'warning',
        },
      )
    } catch (e) {
      return
    }
  }

  const action = staffId.value ? editStaff : addStaff
  const params = {
    ...formData.value,
    userAccount: `${formData.value.userAccount}@${userInfo.tenantShortName}`,
    avatar: formData.value.avatar[0]?.url || '',
  }
  if (staffId.value) params.id = staffId.value
  loading.value = true
  const { code } = await action({ ...params })
  loading.value = false
  if (code === 1) {
    const msg = isEdit.value || infoStatus.value ? '编辑成功' : '添加成功'
    if (userInfo.id === staffId.value) {
      GetUserInfo()
    }
    Message.success(msg)
    handleCancel(true)
    emits('refresh')
  }
}
// 取消
const handleCancel = (status = false) => {
  if (isDetail.value) {
    infoStatus.value = false
    status && getDetailInfo()
    return
  }
  handleClose()
}

const getLoginCloudConfig = async () => {
  const { data } = await getCloudConfig({
    configKey: 'loginConfig',
  })
  loginWithPassword.value = data.loginWithPassword
}

defineExpose({
  open: openDrawer,
  close: closeDrawer,
})
</script>
<style scoped lang="scss">
::v-deep(.el-select--small) {
  width: 100% !important;
}
::v-deep(.el-form-item .el-form-item__label) {
  width: 100%;
  justify-content: flex-start;
  position: relative;
  z-index: 100;
}
::v-deep(.upload-box .notextType-box) {
  display: block;
  float: none;
}

.customLabel{
  width: 100%;
  display: flex;
  justify-content: space-between;
  .copy{
    cursor: pointer;
  }
}
.tip {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: normal;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  > span {
    cursor: pointer;
    color: #366cfe;
  }
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  // transform: scale(1);
  background-color: #f3f3f4;
}

.form-container {
  background-color: #fff;
  padding: 16px 0;
  ::v-deep .el-col {
    margin-bottom: 10px;
  }
}
.card {
  border-radius: 8px;
  opacity: 1;
  /* 背景/bg-white1 */
  /* 样式描述：卡片 */
  background: #ffffff;
  padding: 0 16px;
}
.card-title {
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  display: flex;
  align-items: center;
  letter-spacing: 0em;
  /* 信息/font-black1 */
  /* 样式描述：强调信息 */
  color: rgba(0, 0, 0, 0.9);
  height: 48px;
}
</style>
